module.exports = __webpack_public_path__ + "img/chenxilin.58790f4e.jpg";